import React from "react";
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Collapse } from 'reactstrap';
import { Translate, withLocalize } from "react-localize-redux";
import AngleDownIcon from '../../img/icons/BBiconsRozbalit';

import "./widget.scss";

class Widget extends React.Component {
    static defaultProps = {
        initialExpanded: false,
        hideHeader: false,
        disableExpand: false,
        bodyStyle: {},
        style: {},
        className: "",
        headerOptions: undefined
    };

    static propTypes = {
        initialExpanded: PropTypes.bool,
        hideHeader: PropTypes.bool,
        disableExpand: PropTypes.bool,
        bodyStyle: PropTypes.object,
        style: PropTypes.object,
        className: PropTypes.string,
        header: PropTypes.string,
        customHeader: PropTypes.element,
        scroll: PropTypes.string,
        headerOptions: PropTypes.object
    };

    state = {
        expanded: this.props.initialExpanded
    };

    render() {
        return (
            <div className={`bb-widget ${this.props.className}`} data-scroll={this.props.scroll} style={this.props.style}>
                {this.props.hideHeader ? null : <div
                    className={classnames('bb-widget-header', { 'bb-widget-closed': !this.state.expanded, 'bb-widget-nonexpandable': this.props.disableExpand })}
                    onClick={e => !e.isDefaultPrevented() && !this.props.disableExpand && this.setState(state => ({ expanded: !state.expanded}))}
                >
                    <span className="bb-widget-header-content">{this.props.header ?
                        <Translate id={this.props.header} options={this.props.headerOptions}/> : this.props.customHeader}
                    </span>
                    {this.props.disableExpand ? null : <AngleDownIcon
                        style={{
                            transform: `scaleY(${this.state.expanded ? -1 : 1})`, transition: 'all .5s ease',
                            width: '1.4em', height: '1.4em'
                        }}
                        className={classnames({ 'print-hidden': !this.state.expanded })}
                    />}
                </div>}
                <Collapse isOpen={this.state.expanded}>
                    <div className={classnames("bb-widget-body", { 'bb-widget-without-header': this.props.hideHeader })} style={this.props.bodyStyle}>
                        {this.props.children}
                    </div>
                </Collapse>
            </div>
        )
    }
}

export default withLocalize(Widget);